/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {NgModule} from '@angular/core';
import {ClrAlertModule} from './alert/alert.module';
export class ClrEmphasisModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{exports: [ClrAlertModule]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrEmphasisModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrEmphasisModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrEmphasisModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
